<template>
  <div >
    <div style="background: #f6f6f6;padding: 3vw 3vw 10vw 3vw;">
      <div style="width: 95vw;margin: 0 auto;padding: 5vw 2vw;background: #ffffff;border-radius: 10px;">
       <h2> {{obj.dise_name}}</h2>
       <div style="margin-top: 2vw;"><span style="margin-right: 10vw;font-weight: 600">科室</span>{{obj.department_name}}</div>
     </div>
    </div>
     <div style="background: #ffffff;">
      <div class="tab-slider">
        <div class="tab">
        <span style="" v-for="(item, index) in list" v-bind:class="{active: actived == index}" @click="toggle(index)">
          <span >{{item.title}}</span>
          <div v-if="actived == index" style="width: 8vw;height: 6px;position: absolute;left: 4vw;top: 6vw;background-color: #22c089;border-radius: 50% 0px 50% 0px;transform: skewX(150deg);"></div>
        </span>
        </div>
        <div class="tab-content">
        <div class="wrapbox clearboth">
          <div class="item" :style="{ width: width + 'px' }" v-for="(item, index) in list">
            <div v-show="actived == index">
              <span v-if="item.rows != null">
            <div v-for="(items, index) in item.rows" >
              <span v-if="canParseJSON(items.content)">
                <span v-if="JSON.parse(items.content).length">
                 <div style="margin-top: 1vw;display: flex;align-items: center;" v-for="(itemss, index) in JSON.parse(items.content)">
                  <div><span style="width: 10px;height: 10px;background: #ffffff;display: inline-block;background-color: #22c089;border-radius: 50%;margin-right: 8px;"></span></div> 
                  {{itemss}}
                </div>
                </span>
              </span>
              <span v-else>
                <span v-if="items.type == 'image'">
                  <img  style="max-width: 100%;height: auto;display: block;" :src="items.content" alt=""/>
                </span>
                <span v-else style="margin-top: 1vw;display: flex;align-items: center;">
                  <div><span style="width: 10px;height: 10px;background: #ffffff;display: inline-block;background-color: #22c089;border-radius: 50%;margin-right: 8px;"></span></div>
                   {{items.content}}
                </span>
              </span>
            </div>
          </span> 
           <span v-if="item.tags != null">
              <div v-for="(items, index) in item.tags" >
                <div style="font-size: 18px;font-weight: 600;padding:3vw 0vw">{{items.title}}</div>
                <div  v-for="(itemss, index) in items.rows" >
                  <span v-if="itemss.type == 'image'">
                  <img  style="max-width: 100%;height: auto;display: block;" :src="itemss.content" alt=""/>
                </span>
                <span v-else style="margin-top: 1vw;display: flex;align-items: center;">
                  <div><span style="width: 10px;height: 10px;background: #ffffff;display: inline-block;background-color: #22c089;border-radius: 50%;margin-right: 8px;"></span></div>
                   {{itemss.content}}
                </span>
                </div>
              </div>
           </span>
            </div>
          
          </div>
        </div>
        </div>
 </div>
     </div>
     <div style="font-size: 14px;padding-left: 6vw;">来源：<span style="color:#409eff" @click="xhjk">小荷健康</span></div>
     <div style="color:#409eff;font-size: 14px;padding-left: 6vw;" @click="xhjk">https://m.xiaohe-jiankang.com/medical/disease/list/1?open_time=1716778545650&last_page_item_id=</div>
     <div style="font-size: 12px;color: #ccc;padding-left: 6vw;">平台内容来自网络，转载已标明出处，如有侵权请联系我们立删。</div>
  </div>
</template>
<script>
import { illnessdetail } from '@/api/activity'
export default {
  data() {
    return {
      width:window.innerWidth,
      actived:0,
      dise_name:'',
      obj: [],
      list:[],
      items: []
    };
  },
  // beforeCreate() {
  //   document
  //     .querySelector("#app")
  //     .setAttribute("style", "background-color:#f6f6f6");
  // },
  mounted() {
    this.getData()
  },
  methods: {
    xhjk() {
      window.location.href = 'https://m.xiaohe-jiankang.com/medical/disease/list/1?open_time=1716778545650&last_page_item_id='
    },
    canParseJSON(str) {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
},
    getData() {
      
      illnessdetail(this.$route.query.name).then((res)=>{
        console.log(JSON.parse(res.data).data.storeState)
        this.obj = JSON.parse(res.data).data.storeState.todo.data
        this.list = JSON.parse(res.data).data.storeState.todo.data.data.content
        document.querySelector(".tab-content .wrapbox").style.width = window.innerWidth * this.list.length + 'px';
       
        console.log(this.list)
      })
    },
    toggle(index){
    this.actived = index;     
    document.querySelector(".tab-content .wrapbox").style.webkitTransform = "translateX(-" + (this.actived * window.innerWidth) + "px)";
   }
  },
};
</script>
<style scoped>
.clearboth::after{
  content:"";
  display:block;
  clear:both;
 }
 .tab-slider{
  height:auto;
  width:100%;
  overflow: hidden;
  /* margin:50px auto; */
 }
 .tab-slider .tab{
  /* display:flex; */
  width: 100%;
  overflow-x: auto; /* 当内容宽度超过div时，显示横向滚动条 */
  white-space: nowrap; /* 防止内容换行 */
  height:40px;
  line-height:40px;
  /* background:#ccc; */
 }
 .tab-slider .tab span{
  display:inline-block;
  /* width:20vw; */
  text-align:center;
  cursor:default;
  position: relative;
  z-index: 111;
  padding: 0vw 2vw;
 }
 .tab-slider .tab .active{
  text-align: center;
  font-weight: 700;
 }
 .tab-slider .tab-content{
  /* height:300px; */
  width:100%;
  overflow:hidden;
 }
 .tab-slider .tab-content .item{
  float:left;
  padding: 6vw;
  margin-top: 3vw;
  /* height:300px;
  width:100%;
  line-height:300px;
  text-align:center; */
  /* font-size:60px; */
  /* background:#eee; */
 }
 .tab-slider .wrapbox{
  width:100%;
  transition: all 1s;
 }
</style>


// WEBPACK FOOTER //
// src/views/screendetail.vue